<template>
  <v-dialog v-model="dialog" @input="v => v || closeDialog()" max-width="688px">
    <v-card class="d-flex justify-content-center">
      <v-card-text class="content-modl">
        <v-img
          @click="closeDialog"
          class="cancel-image"
          src="../../assets/icons/cancel.png"
          height="15px"
          width="15px"
        />
        <div class="text-center py-5">
          <h3>{{ dialogTitle }}</h3>
        </div>

        <div v-if="userTypeFilter">
          <p>{{ "lng_select_usertype_txt" | translate }}</p>
          <v-radio-group v-model="selectedUserType" row>
            <v-radio :label="'lng_dealer_txt' | translate" value="10" ></v-radio>
            <v-radio :label="'lng_service_partner_txt' | translate" value="11" ></v-radio>
            <v-radio :label="'lng_dealer_service_partner_txt' | translate" value="12" ></v-radio>
            <!-- <v-radio :label="'lng_multiuser_txt' | translate" value="2" ></v-radio> -->
          </v-radio-group>
        </div>
        <div v-else>
          <div v-if="showEmployee">
            <p>{{ "lng_employee_txt" | translate }}</p>
            <v-select
              v-model="selectedEmployee"
              class="mt-0 pt-0"
              :items="employeesData"
              :value="employeesData.id"
              item-text="name"
              item-value="id"
              menu-props="auto"
              return-object
            ></v-select>
          </div>  

          <p>{{ "lng_th_sysStatus_txt" | translate }}</p>
          <v-radio-group v-model="sysService" row>
            <v-radio :label="'lng_no_service_txt' | translate" value="no" ></v-radio>
            <v-radio :label="'lng_soon_service_txt' | translate" value="soon" ></v-radio>
            <v-radio :label="'lng_due_service_txt' | translate" value="due" ></v-radio>
          </v-radio-group>

          <p>{{ "lng_th_sysState_txt" | translate }}</p>
          <v-radio-group v-model="sysState" row>
            <v-radio :label="'lng_system_state_ok_txt' | translate" value="0" ></v-radio>
            <v-radio :label="'lng_system_state_alarm_txt' | translate" value="1" ></v-radio>
            <v-radio :label="'lng_system_state_offline_txt' | translate" value="2" ></v-radio>
          </v-radio-group>
        </div>
        <div class="d-flex justify-content-center py-5 mt-3">
          <v-btn color="#0B7894" dark @click="applyFilter">
          {{ "lng_apply_filters_btn" | translate }}</v-btn>
          <v-btn color="#0B7894" dark @click="clearFilter" class="mx-2">
          {{ "lng_clear_filters_btn" | translate }}</v-btn>
        </div>

      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>

export default {
  name: "FiltersDialog",
  data() {
    return {
      dialog: false,
      selectedEmployee: null,
      sysService: null,
      sysState: null,
      showEmployee: true,
      selectedUserType: null
    };
  },
  props: {
    openDialog: {
      type: Boolean,
      default: false
    },
    closeDialog: {
      type: Function,
      default: undefined
    },
    dialogTitle: {
      type: String,
      default: "Dialog"
    },
    dealerToken: {
      type: String,
      default: ""
    },
    employeesData: {
      type: Array,
      default: () => []
    },
    userTypeFilter: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    openDialog: function(newVal) {
      this.dialog = newVal;
    }
  },
  mounted() {
    if(this.$route.path === "/admin-home"){
      this.showEmployee = false;
    }
  },
  methods: {
    applyFilter(){
      if(this.userTypeFilter){
        this.$emit("applyFilters", { "userType": this.selectedUserType })
      } else {
        this.$emit("applyFilters", {
          "employee": this.selectedEmployee, "service": this.sysService, "state": this.sysState
        })
      }
      this.closeDialog();
    },
    clearFilter(){
      this.selectedEmployee = null;
      this.sysService = null;
      this.sysState = null;
      this.selectedUserType = null;
      if(this.userTypeFilter){
        this.$emit("applyFilters", { "userType": this.selectedUserType })
      } else {
        this.$emit("applyFilters", { "employee": null, "service": null, "state": null })
      }
      this.closeDialog();
    }
  }
};
</script>

<style scoped>
.theme--light.v-card > .v-card__text {
  color: #000;
  width: 95%;
}
.cancel-image {
  position: absolute;
  top: 1rem;
  right: 1rem;
}
.v-overlay.v-overlay--active.theme--dark {
  z-index: 99991 !important;
}
.v-dialog__content.v-dialog__content--active {
  z-index: 99992 !important;
}
.v-application p, p {
  margin-bottom: 0;
  margin-top: 1rem;
}
.v-input--selection-controls {
  margin-top: 0rem;
}
.v-radio > label {
  margin-bottom: 0;
}
</style>
